import type * as React from 'react'

import { useThreadDragDrop } from '~publish/hooks/useThreadDragDrop'
import { useIsIntegrationUploading } from '~publish/legacy/integrations-bar/state/useIsIntegrationUploading'

import { SortableThreadItem } from '../SortableThreadItem'
import { CommonThread } from './CommonThread'
import type { ThreadComponentProps } from './types'
import ComposerStore from '../../stores/ComposerStore'
import styles from '../css/DragDropThread.module.css'

export const DragDropThread = (props: ThreadComponentProps) => {
  const { draft } = props
  const { isIntegrationUploading } = useIsIntegrationUploading()
  const activeThreadId = ComposerStore.getActiveThreadId()
  const {
    sensors,
    handleDragEnd,
    sortableIds,
    modifiers,
    collisionDetection,
    DndContext,
    SortableContext,
    verticalListSortingStrategy,
  } = useThreadDragDrop({ draft })

  const renderWrapper = (children: React.ReactNode) => (
    <div className={styles.dndContextWrapper}>
      <DndContext
        sensors={sensors}
        modifiers={modifiers}
        collisionDetection={collisionDetection}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={sortableIds}
          strategy={verticalListSortingStrategy}
        >
          {children}
        </SortableContext>
      </DndContext>
    </div>
  )

  const renderThreadItem = (children: React.ReactNode, index: number) => (
    <SortableThreadItem
      key={index}
      id={`thread-${index}`}
      index={index}
      disabled={isIntegrationUploading || index === activeThreadId}
      isActiveThread={index === activeThreadId}
    >
      {children}
    </SortableThreadItem>
  )

  return (
    <CommonThread
      {...props}
      renderWrapper={renderWrapper}
      renderThreadItem={renderThreadItem}
    />
  )
}
